<template>
  <div class="container-wrapper">
  <div class="container">
      <div class="item div1" data-aos="fade-down">
        <router-link :to="{ name: 'Hoodies' }">
          <div class="image-container">
            <img src="/images/hoodies.png" alt="" />
            <p class="text">Hoodies</p>
          </div>
        </router-link>
      </div>
      <div class="item div2" data-aos="fade-up">
        <router-link :to="{ name: 'Coats' }">
          <div class="image-container">
            <img src="/images/coats.png" alt="" />
            <p class="text">Coats</p>
          </div>
        </router-link>
      </div>
      <div class="item div3" data-aos="fade-down">
        <router-link :to="{ name: 'Pants' }">
          <div class="image-container">
            <img src="/images/pants.png" alt="" />
            <p class="text">Pants</p>
          </div>
        </router-link>
      </div>
      <div class="item div4" data-aos="fade-up">
        <router-link :to="{ name: 'Tshirts' }">
          <div class="image-container">
            <img src="/images/shirts.png" alt="" />
            <p class="text">T-Shirts</p>
          </div>
        </router-link>
      </div>
      <div class="item div5" data-aos="fade-down">
        <router-link :to="{ name: 'Sweatshirts' }">
          <div class="image-container">
            <img src="/images/sweatshirts.png" alt="" />
            <p class="text">Sweatshirts</p>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped>
.container-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 60px;
  white-space: nowrap;
  transform-origin: center center;
}

.image-container {
  position: relative;
  flex-shrink: 1;
}

.image-container:hover img {
  filter: brightness(50%);
}


.text {
  text-transform: uppercase;
  color: #fff;
  font-size: 5.6rem;
  font-family: "Mabry Pro";
  font-weight: 500;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(90deg);
  white-space: nowrap;
}

@media screen and (min-width: 240px) and (max-width: 480px) {
  .container-wrapper {
    display: none;
  }
}

@media screen and (min-width: 481px) and (max-width: 768px) {
  .container-wrapper {
    display: none;
  }
  
}

@media screen and (min-width: 769px) and (max-width: 1024px) {
  .container-wrapper {
    display: none;
  }
}

@media screen and (min-width: 1025px) and (max-width: 1200px) {
  .container-wrapper {
    display: none;
  }
}

@media screen and (min-width: 1200px) and (max-width: 1900px) {
  .container-wrapper {
    display: none;
  }
}

</style>

